<template>
  <two-columns :fluid="!isDesktop">
    <template #title>
      <div class="col-12 col-md-12 col-lg-6 offset-lg-5">
        <heading :class="[{ 'px-4': isMobile , 'center': isTablet }]">{{ pageTitle }}</heading>
      </div>
    </template>
    <template #left>
      <div class="member-benefits col-12 col-md-12 col-lg-4">
        <checkmark-styled-list
          :class="[{'px-4': isMobile }]"
          :title="benefitsListTitle"
          :list="benefitsList"
        />
      </div>
    </template>
    <template #right>
      <div class="sign-up-block col-12 col-md-12 col-lg-6 offset-lg-1">
        <div class="sign-up-form">
          <div class="already-a-member">
            <p>{{ $t('signUpPage.haveAccount') }}
              <a
                :href="loginUrl"
                :title="$t('signUpPage.loginLinkText')"
                @click="gtmLoginFromCreateProfile"
              >
                {{ $t('signUpPage.loginLinkText') }}
              </a>
            </p>
          </div>
          <sign-up-form />
        </div>
      </div>
    </template>
  </two-columns>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import gtmProfile from 'services/AirBaltic/GTM/Profile'

  export default {
    components: {
      TwoColumns: () => import(/* webpackChunkName: "layout-two-columns" */ 'layouts/templates/TwoColumns'),
      Heading: () => import(/* webpackChunkName: "heading" */ 'components/Heading'),
      CheckmarkStyledList: () => import(/* webpackChunkName: "checkmark-styled-list" */ 'components/CheckmarkStyledList'),
      SignUpForm: () => import(/* webpackChunkName: "profile-signup-form" */ 'containers/Pages/Profile/SignupForm')
    },
    computed: {
      ...mapState('createProfile', [
        'pageTitle',
        'benefitsListTitle',
        'benefitsList',
        'loginUrl'
      ]),
      ...mapGetters('device', [
        'isMobile',
        'isTablet',
        'isDesktop'
      ])
    },

    methods: {
      gtmLoginFromCreateProfile() {
        gtmProfile.loginCreateProfileAction()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~assets/styles/common.scss";

  .sign-up-block {

    .sign-up-form {
      background: $blue-bg;

      .already-a-member {
        padding: 20px;
        border-bottom: 1px solid $blue-dividers;

        color: $blue-dark;
        font-size: em(14);
        letter-spacing: 0;
        line-height: 18px;

        @include bp-mf-tablet {
          font-size: em(16);
          padding: 24px 40px;
          text-align: center;
        }

        @include bp-mf-desktop {
          text-align: left;
        }

        p {
          margin: 0;
        }

        a {
          display: inline-block;
          color: $blue-medium;
          margin-left: 4px;
          text-decoration: none;
          font-weight: 500;
        }
      }
    }
  }

  .member-benefits {
    order: 1;

    @include bp-mf-desktop {
      order: 0;
    }
  }
</style>
